import { Controller } from "stimulus";

class PriceController extends Controller {
  static outlets = ["omnibusModal"];
  static targets = ["price"];

  onClick(e) {
    e.preventDefault();
    this.omnibusModalOutlet.toggleVisibilty();
  }

  updatePrice(e) {
    if (this.hasPriceTarget) {
      this.priceTarget.innerHTML = e.price;
    }
  }
}

Stimulus.register("price", PriceController);
